/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import LintLinkModal from '../../modal/modal';
import { ModalTitle } from './modalTitle';
import { ModalBody } from './modalBody';
import { LinksModalProps } from './linkModalInterface';
import { useDispatch, useSelector } from 'react-redux';
import { setCheck, setLink } from '../../../redux/button/button';
import './linkMdodal.scss';

const courseLink = (details: {
  id: string;
  items_url: string;
  html_url: string;
  full_url: string;
  url: string;
  filename: string;
}) => {
  let applyId = details?.items_url;
  if (applyId?.includes('modules')) {
    applyId = applyId.replace('/api/v1', '').replace('/items', '');
  }
  const pages = details?.html_url;
  const navigation = details?.full_url;
  const files = details?.url;
  return applyId || navigation || pages || files;
};

const LinksModal: React.FC<LinksModalProps> = ({
  showModal,
  onHide,
  type,
  url,
  handleApplyFromLink,
}) => {
  const handleType = type === 'link';
  const [activeTab, setActiveTab] = useState('courselinks');
  const [selectedTypeTabOpen, setSelectedTypeTabOpen] = useState('new');
  const [selectedDirection, setSelectedDirection] = useState('Redirect');
  const [selectedLink, setSelectedLink] = useState<any>(null);
  const dispatch = useDispatch();
  const sectionId = useSelector((state: any) => state.button.sectionId);
  const errors = useSelector((state: any) => state.button.errors);

  const isValidURL = (url: string) => {
    try {
      new URL(url);
      return true;
    } catch (error) {
      return error;
    }
  };
  const setLinkValue = (link: string, error: any) => {
    dispatch(
      setLink({
        link: url || link,
        errors: { ...error },
      }),
    );
  };
  const handleLinkModalApply = (finalLink: string) => {
    if (handleType && handleApplyFromLink) {
      handleApplyFromLink(finalLink, selectedTypeTabOpen === 'new');
    }
  };
  const handlApply = () => {
    let fail = { ...errors };
    delete fail['link'];
    let finalLink = '';
    const isemail = activeTab === 'email';
    const emailPattern =
      /^(?!\.)(?!.*\.\.)[\w!#$%&'*+/=?`{|}~^.-]+(?:\.[\w!#$%&'*+/=?`{|}~^-]+)*@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z0-9]{2,6}$/;
    if (activeTab === 'courselinks') {
      const link = courseLink(selectedLink);
      const refinedId = sectionId?.includes('#') ? sectionId?.replace(/^#+/, '') : sectionId;
      finalLink = selectedDirection === 'Redirect' ? link : `${link}#${refinedId}`;
    } else if (
      activeTab === 'webaddress' &&
      selectedLink?.webAddress.trim() !== '' &&
      isValidURL(selectedLink?.webAddress) === true
    ) {
      finalLink = selectedLink?.webAddress;
    } else if (
      activeTab === 'email' &&
      selectedLink?.email?.trim() !== '' &&
      emailPattern.test(selectedLink.email)
    ) {
      finalLink = `mailto:${selectedLink.email}`;
    } else {
      fail = {
        ...fail,
        [isemail ? 'email' : 'webAddress']: `Enter a valid ${
          activeTab === 'email' ? 'email' : 'web'
        } address`,
      };
      setLinkValue('', fail);
      setSelectedLink(null);
      return;
    }
    handleClose();
    setLinkValue(finalLink, fail);
    dispatch(
      setCheck({
        isChecked: selectedTypeTabOpen === 'new',
      }),
    );
    handleLinkModalApply(finalLink);
  };

  const handleClose = () => {
    onHide(false);
    setActiveTab('courselinks');
    setSelectedDirection('Redirect');
    setSelectedTypeTabOpen('new');
    setSelectedLink(null);
  };

  return (
    <LintLinkModal
      id='buttonlink'
      show={showModal}
      className='LinksModal'
      onHide={() => {
        handleClose();
      }}
      title={<ModalTitle />}
      size='lg'
      body={
        <ModalBody
          setActiveTab={setActiveTab}
          activeTab={activeTab}
          setSelectedTypeTabOpen={setSelectedTypeTabOpen}
          selectedTypeTabOpen={selectedTypeTabOpen}
          setSelectedDirection={setSelectedDirection}
          selectedDirection={selectedDirection}
          setSelectedLink={setSelectedLink}
          selectedLink={selectedLink}
          type={type}
        />
      }
      footer={
        <div className='footerBn'>
          <Button
            className='cancelBTn'
            variant='secondary'
            onClick={() => {
              handleClose();
            }}
          >
            Cancel
          </Button>
          <Button className='applyBtn' disabled={selectedLink === null} onClick={handlApply}>
            Apply
          </Button>
        </div>
      }
    />
  );
};

export default LinksModal;
